import Cropper from 'cropperjs'
window.Cropper = Cropper
